module.exports = __webpack_public_path__ + "static/media/just-logo.989d4518.svg";